import React, { ChangeEventHandler, useCallback } from "react";
import { styled } from "styled-components";

import { FieldLabel } from "affinityUI/form/components";
import { Input } from "affinityUI/form/inputs/input";

export const Field = styled.div<{ $flex?: number }>`
  display: flex;
  ${({ $flex }) => $flex && `flex: ${$flex}`};
`;

export enum DateFiledTypes {
  DAY = "day",
  MONTH = "month",
  YEAR = "year",
}

const config = {
  [DateFiledTypes.DAY]: {
    label: "Day",
    placeholder: "DD",
    flex: 1,
  },
  [DateFiledTypes.MONTH]: {
    label: "Month",
    placeholder: "MM",
    flex: 1,
  },
  [DateFiledTypes.YEAR]: {
    label: "Year",
    placeholder: "YYYY",
    flex: 2,
  },
};

export const DatePart: React.FC<
  Omit<React.ComponentProps<typeof Input>, "onChange"> & {
    name: string;
    error?: unknown;
    type: DateFiledTypes;
    onChange: (fieldData: { name: string; value: string }) => void;
  }
> = ({ name, error, type, onChange, ...props }) => {
  const id = `${name}.${type}`;
  const { label, placeholder, flex } = config[type];

  const handleChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      onChange({ name: type, value: e.target.value });
    },
    [onChange, type]
  );

  return (
    <Field $flex={flex}>
      <FieldLabel visuallyHidden htmlFor={id}>
        {label}
      </FieldLabel>
      <Input
        $error={error}
        type="number"
        placeholder={placeholder}
        id={id}
        name={id}
        onChange={handleChange}
        {...props}
      />
    </Field>
  );
};
